// Meta Pixel — integrazione con gate di consenso marketing (GDPR).
// Il pixel NON viene caricato e NON invia nulla finché non viene chiamato grantMarketingConsent()
// (dalla CMP o dal banner consenso). Prima di quel momento trackMeta/trackMetaCustom sono no-op
// e nessuno script/cookie di Meta esiste nella pagina.

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
let activated = false;
let loadingPromise = null;
const consentListeners = new Set();

const loadPixel = () => {
  if (loadingPromise) return loadingPromise;
  loadingPromise = new Promise((resolve, reject) => {
    if (!PIXEL_ID) return reject(new Error("REACT_APP_META_PIXEL_ID mancante"));

    // Base code Meta (come lo snippet ufficiale): prima del caricamento di fbevents.js
    // le chiamate si accodano in fbq.queue; dopo il caricamento fbevents MUTA questa
    // funzione aggiungendo callMethod, e le chiamate devono delegare a callMethod.
    // Senza questo check lo stub accoderebbe per sempre e gli eventi successivi
    // al load (PreventivoAvviato, Lead, consent revoke) non raggiungerebbero mai Meta.
    const fbq = function (...args) {
      if (fbq.callMethod) fbq.callMethod(...args);
      else fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;

    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Meta Pixel: caricamento fbevents.js fallito"));
    document.head.appendChild(s);

    fbq("init", PIXEL_ID);
    fbq("track", "PageView"); // unico PageView iniziale; i successivi li gestisce MetaPixelTracker
  });
  return loadingPromise;
};

// Da chiamare SOLO dopo consenso marketing affermativo. Sicura da chiamare più volte.
export const grantMarketingConsent = () => {
  if (activated) return;
  activated = true;
  loadPixel()
    .then(() => consentListeners.forEach((fn) => fn()))
    .catch((err) => {
      activated = false;
      loadingPromise = null;
      console.error(err);
    });
};

export const hasMarketingConsent = () => activated;

// Revoca consenso marketing: nessun evento successivo viene più inviato a Meta
export const revokeMarketingConsent = () => {
  activated = false;
  if (typeof window.fbq === "function") {
    try {
      window.fbq("consent", "revoke");
    } catch {
      /* noop */
    }
  }
  ["_fbp", "_fbc"].forEach((n) => {
    document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${location.hostname}`;
  });
};

// Il tracker delle route si registra qui per emettere eventi rimasti in attesa del consenso
export const onConsentGranted = (fn) => {
  consentListeners.add(fn);
  return () => consentListeners.delete(fn);
};

export const trackMeta = (name, params = {}) => {
  if (!activated || typeof window.fbq !== "function") return;
  window.fbq("track", name, params);
};

export const trackMetaCustom = (name, params = {}) => {
  if (!activated || typeof window.fbq !== "function") return;
  window.fbq("trackCustom", name, params);
};

// Punto di aggancio globale per la CMP/banner consenso (es. onAccept → window.loiGrantMarketingConsent())
if (typeof window !== "undefined") window.loiGrantMarketingConsent = grantMarketingConsent;
